import React from "react";

type StatusPillProps = {
  status?: string | null;
};

function StatusPill({ status }: StatusPillProps) {
  const label = status || "Unknown";
  const lower = label.toLowerCase();

  let color = "bg-slate-100 text-slate-700 border-slate-200";
  if (lower === "active")
    color = "bg-emerald-50 text-emerald-700 border-emerald-100";
  if (lower === "closed")
    color = "bg-slate-100 text-slate-600 border-slate-200";

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${color}`}
    >
      {label}
    </span>
  );
}

export default StatusPill;
